import { render, staticRenderFns } from "./components.vue?vue&type=template&id=23ba3712&"
import script from "./components.vue?vue&type=script&lang=js&"
export * from "./components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports